import { AttackService } from '../../attack/attack.service';
import { Injectable, OnInit } from '@angular/core';
import { Attack, AttackProfile } from '../../attack/attack';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import {Message} from '../../publisher/message';
import {PublisherService} from '../../publisher/publisher.service';


@Injectable()
export class ConfigService {

    availableAttackProfilesSubject: BehaviorSubject<AttackProfile[]> = new BehaviorSubject<AttackProfile[]>([]);

    currentAttackSubject: BehaviorSubject<Attack> = new BehaviorSubject<Attack>({ ID: '', Status: 'Unknown', FailReason: '', CreationDate: '', StartDate: '', StopDate: '', AttackParams: { TargetIpAddress: '', TargetPortNumber: 80, AttackProfile: 'udp-flood-512B', AttackSize: 'small', Duration: 600, SourceRegionName: '' }, Metrics: { TxFrameRate: 0, Attacks: 0, AttackRate: 0, TxDataRate: 0, TxFrames: 0, TxData: 0 } });

    historySubject: BehaviorSubject<Attack[]> = new BehaviorSubject<Attack[]>([]);

    history: Attack[];

    private userAuthenticationChannel: Observable<Message>;


    constructor(private attackService: AttackService, private publisherService: PublisherService) {
        var me = this;

        this.userAuthenticationChannel = this.publisherService.subscribeToChannel('user-authentication');

        this.userAuthenticationChannel.subscribe(
            (newUser) =>{
                me.history = [];
                me.history.length = 15;
                me.historySubject.next(me.history);

            }
        );


        this.attackService.currentAttack.subscribe(attack => {
            this.currentAttackSubject.next(attack);
        });

        this.attackService.getAvailableProfiles().subscribe(profiles => {
            this.availableAttackProfilesSubject.next(profiles);
        });

        // Get the original history when starting up, then push the next attack to the array as its running.
        this.attackService.allAttacks.subscribe(attacks => {
            attacks.sort((a, b) => -a.CreationDate.localeCompare(b.CreationDate));

            me.history = attacks;
            me.history.length = 15;
            me.historySubject.next(me.history);
            this.attackService.currentAttack.subscribe(attack => {
                if (!attack) {
                    return;
                }

                let itemIndex = this.history.findIndex(item => (item != null) && item.ID == attack.ID);
                if (itemIndex >= 0) {
                    me.history[itemIndex] = attack;
                } else {
                    me.history.splice(0, 0, attack);
                }

                me.historySubject.next(me.history);
            });
        });
    }

    convertSecondsToHHMMSS(seconds: number){
        if(seconds < 0){
            seconds = 0;
        }
        const hours = ("0" + Math.floor( seconds / 3600 )).slice(-2);
        const mins = ("0" + Math.floor( (seconds - (+hours * 3600) ) / 60)).slice(-2);
        const secs = ("0" + Math.floor( seconds % 60 )).slice(-2);
        return hours+':'+mins+':'+secs;

    }

    formatDateTime(rawDateTime: string){
      var formattedDateTime = '';
      var formattedMonth = '';
      var formattedDay = '';
      var formattedHour = '';
      var formattedMin = '';
      var formattedSec = '';
      var date = new Date(Date.parse(rawDateTime));
      var day = date.getDate();
      if(day<=9){
        formattedDay='0'+day;
      }else{
        formattedDay=''+day;
      }
      var monthIndex = date.getMonth();
      var month = date.getMonth()+1;
      if(month<=9){
        formattedMonth='0'+month;
      }else{
        formattedMonth=''+month;
      }
      var year = date.getFullYear();
      var minutes = date.getMinutes();
      if(minutes<=9){
        formattedMin='0'+minutes;
      }else{
        formattedMin=''+minutes;
      }
      var hours = date.getHours();
      if(hours<=9){
        formattedHour='0'+hours;
      }else{
        formattedHour=''+hours;
      }
      var seconds = date.getSeconds();
      if(seconds<=9){
        formattedSec='0'+seconds;
      }else{
        formattedSec=''+seconds;
      }
      formattedDateTime = formattedMonth+"."+formattedDay+"."+year+" "+formattedHour+":"+formattedMin+":"+formattedSec
      if(!isNaN(Date.parse(rawDateTime))){
        return formattedDateTime;
      }else{
        return 'N/A';
      }

    }
}



// WEBPACK FOOTER //
// ./src/app/main/config/config.service.ts